// extracted by mini-css-extract-plugin
export default {"root":"SectionHeading_root__bf6NM","title":"SectionHeading_title__grG8E","subtitle":"SectionHeading_subtitle__lEQRI"};